import { CHART_NAME } from '../../../../utils/constants.js';
import {
   getCompetitionFareChangesConfigColumns,
   getCompetitionFareChangesHeatMapColumns,
} from './grid-competition-fare-changes-util.js';

export const getCompetitionFareChangesConfig = (filterBy) => {
   return {
      chartKey: `${CHART_NAME.CHART_COMPETITIVE_CHANGE_FARE}-competition`,
      tableClassName: `competitive-changes-fare-competition`,
      configTree: {
         isSubRows: true,
         childKey: 'subRows',
      },
      configHeatMap: {
         heatMapColumns: getCompetitionFareChangesHeatMapColumns(filterBy),
         colors: { low: '#FF0000', mid: '#FFFFFF', high: '#006633' },
         fontColors: { low: '#FFFFFF', mid: '#000000', high: '#FFFFFF' },
         isHtmlEmbedded: false,
      },
      configColumns: getCompetitionFareChangesConfigColumns(filterBy),
      cssClasses: {
         tooltipCss: `competitive-changes-fare-competition-tooltip`,
      },
   };
};
